<template>
  <layout-private :customer="customer">
    <div class="row row-stats">

      <div class="col-12 col-nav">
        <hr class="hr-salmon">
        <div class="nav-sub-container d-flex">
          <h4>Stats</h4>
          <h4 class="nav-sub-divider">/</h4>
          <ul class="nav nav-tabs nav-sub">
            <li class="nav-item">
              <router-link 
                class="nav-link" 
                :class="{ active: $route.name === 'statsSnapshot' }" 
                :to="{ name: 'statsSnapshot'}"
              >
                Snapshot
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link"
                :class="{ active: $route.name === 'statsPathToHealth' }"
                :to="{ name: 'statsPathToHealth'}"
              >
                Path To Health
              </router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link" to="/stats/Historical">Historical</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/stats/care-progress">Care Progress Report</router-link>
            </li> -->
          </ul>
        </div> <!-- /.nav-sub -->
      </div> <!-- /.col -->

      <div class="col-12 col-filters">
        <div class="row">
          <div class="col-3">
            <select v-model="filterDateRange" class="form-control">
              <option disabled :value="null">Select Date Range</option>
              <option value="yesterday">Yesterday</option>
              <option value="oneWk">1 Week</option>
              <option value="oneMo">1 Month</option>
            </select>
          </div> <!-- /.col -->
          
          <div v-if="showProviderAssistantFilters" class="col-3">
            <p class="loading" v-if="loadingProviders"><i class="far fa-fw fa-pulse fa-spinner"></i> loading providers...</p>
            <p v-if="!loadingProviders && !providers"><em>no providers found in Open Dental</em></p>
            <!-- <label v-if="providers" for="primaryProvider">Primary Provider <small class="light-weight">required</small></label> -->
            <select v-if="providers" id="primaryProvider" v-model="filterPrimaryProvider" class="form-control">
              <option disabled :value="null">Select Primary Provider</option>
              <option :value="null">None</option>
              <option v-for="prov in providers" :value="prov.ProvNum">{{ prov.Abbr }} - {{ prov.LName }}, {{ prov.FName }}</option>
            </select>
          </div>

          <div v-if="showProviderAssistantFilters && providers" class="col-3">
            <!-- <label for="secondaryProvider">Secondary Provider <small class="light-weight">optional</small></label> -->
            <select id="secondaryProvider" v-model="filterSecondaryProvider" class="form-control">
              <option disabled :value="null">Select Secondary Provider</option>
              <option :value="null">None</option>
              <option v-for="prov in providers" :value="prov.ProvNum">{{ prov.Abbr }} - {{ prov.LName }}, {{ prov.FName }}</option>
            </select>
          </div>

          <div v-if="showProviderAssistantFilters" class="col-3">
            <p class="loading" v-if="loadingAssistants"><i class="far fa-fw fa-pulse fa-spinner"></i> loading assistants...</p>
            <p v-if="!loadingAssistants && !assistants"><em>no assistants found in Open Dental</em></p>
            <!-- <label v-if="assistants" for="assistant">Assistant <small class="light-weight">optional</small></label> -->
            <select v-if="assistants" id="assistant" v-model="filterAssistant" class="form-control">
              <option disabled :value="null">Select Assistant</option>
              <option :value="null">None</option>
              <option v-for="asst in assistants" :value="asst.UserNum">{{ asst.UserName }}</option>
            </select>
          </div>

        </div> <!-- /.row -->
      </div> <!-- /.col -->

      <div class="col-12">
        <router-view :filterDateRange="filterDateRange" :filterDateRangeTimestamps="filterDateRangeTimestamps" :filterPrimaryProvider="filterPrimaryProvider" :filterSecondaryProvider="filterSecondaryProvider" :filterAssistant="filterAssistant"></router-view>
      </div> <!-- /.col -->

    </div> <!-- /.row -->
  </layout-private>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import LayoutPrivate from '../components/LayoutPrivate.vue'
import ListErrors from '../components/ListErrors.vue'
import moment from 'moment-timezone';

export default {
  props: ['customer'],
  components: {
    LayoutPrivate, ListErrors,
  },
  data() {
    return {
      filterDateRange: null,
      filterPrimaryProvider: null,
      filterSecondaryProvider: null,
      filterAssistant: null,
      providers: null,
      assistants: null,
      loadingProviders: false,
      loadingAssistants: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter']),
    showProviderAssistantFilters() {
      return this.$route.name !== 'statsPathToHealth';
    },
   filterDateRangeTimestamps() {
      if (!this.filterDateRange) return null;
      let start;
      const end = moment.tz('America/Chicago').subtract(1, 'days').endOf('day').unix();
      // if filterDateRange is 'yesterday', get start and end timestamps for yesterday
      if (this.filterDateRange === 'yesterday') {
        start = moment.tz('America/Chicago').subtract(1, 'days').startOf('day').unix();
      }
      // if it's oneWk, get start and end timestamps for the last 7 days
      if (this.filterDateRange === 'oneWk') {
        start = moment.tz('America/Chicago').subtract(8, 'days').startOf('day').unix();
      }
      // if it's oneMo, get start and end timestamps for the last 30 days
      if (this.filterDateRange === 'oneMo') {
        start = moment.tz('America/Chicago').subtract(1, 'months').subtract(1, 'days').startOf('day').unix();
      }
      return { start, end };
    },
  },
  watch: {
    custom_claims(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (this.showProviderAssistantFilters) {
          this.loadProviders();
          this.loadAssistants();
        }
      }
    },
    '$route.name'(newName, oldName) {
      if (newName === oldName) {
        return;
      }
      if (!this.showProviderAssistantFilters) {
        this.providers = null;
        this.assistants = null;
        this.filterPrimaryProvider = null;
        this.filterSecondaryProvider = null;
        this.filterAssistant = null;
        return;
      }
      if (this.custom_claims) {
        this.loadProviders();
        this.loadAssistants();
      }
    },
  },
  methods: {
    async loadProviders() {
      if (!this.showProviderAssistantFilters) {
        return;
      }
      // console.log('loading providers');
      const uid = this.user?.uid;
      const customerId = this.custom_claims?.customerId;
      const locationId = this.custom_claims?.authorized_location;
      if (!uid || !customerId || !locationId) {
        // Required parameters missing, exit early
        console.log('missing parameters for loadProviders');
        return;
      }
      this.loadingProviders = true;
      try {
        const loadProviders = Vue.functions.httpsCallable('loadProviders');
        const payload = { uid, customerId, locationId };
        const result = await loadProviders(payload);
        if(result.data && Array.isArray(result.data) && result.data.length) {
          // console.log('loaded providers count:',result.data.length);
          this.providers = result.data.sort((a,b) => (a.Abbr > b.Abbr) ? 1 : ((b.Abbr > a.Abbr) ? -1 : 0));
        } else {
          console.log('no providers found');
        }
      } catch (err) {
        console.error('Failed to load providers:', err);
        this.providers = null;
      }
      this.loadingProviders = false;
    },
    async loadAssistants() {
      if (!this.showProviderAssistantFilters) {
        return;
      }
      // console.log('loading assistants');
      const uid = this.user?.uid;
      const customerId = this.custom_claims?.customerId;
      const locationId = this.custom_claims?.authorized_location;
      if (!uid || !customerId || !locationId) {
        // Required parameters missing, exit early
        console.log('missing parameters for loadAssistants');
        return;
      }
      this.loadingAssistants = true;
      try {
        const loadAssistants = Vue.functions.httpsCallable('loadAssistants');
        const payload = { uid, customerId, locationId };
        const result = await loadAssistants(payload);
        if(result.data && Array.isArray(result.data) && result.data.length) {
          this.assistants = result.data.sort((a,b) => (a.UserName > b.UserName) ? 1 : ((b.UserName > a.UserName) ? -1 : 0));
        } else {
          console.log('no assistants found');
        }
      } catch (err) {
        console.error('Failed to load assistants:', err);
        this.providers = null;
      }
      this.loadingAssistants = false;
    },
  },
  mounted() {
    if (this.custom_claims && this.showProviderAssistantFilters) {
      this.loadProviders();
      this.loadAssistants();
    }
  },
  
};
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.col-filters {
  margin: 30px 0;
}
</style>
